/**
 * External dependencies
 */
import { registerBlockType } from '@wordpress/blocks';
import { Icon, box } from '@wordpress/icons';
import { getSetting } from '@woocommerce/settings';

/**
 * Internal dependencies
 */
import metadata from './block.json';
import { Edit, Save } from './edit';

const cfeSettings = getSetting('thwcfe-block-integration_data', '');
const { allSections } = cfeSettings;
const { additional_info } = allSections || {};

if (additional_info && Object.keys(additional_info).length > 0) {

    const sectionTitle = additional_info.title || 'Additional Information';
 
    const updatedMetadata = {
        ...metadata,
        attributes: {
            ...metadata.attributes,
            title: {
                ...metadata.attributes.title,
                default: sectionTitle
            },
            description : {
                ...metadata.attributes.description,
                default: additional_info.subtitle || ''
            },
            sectionData: {
                type: 'object',
                default: additional_info,
            },
        },
    };

    registerBlockType( updatedMetadata, {
        
        icon: {
            src: <Icon icon={ box } />,
        },
        edit: Edit,
        save: Save,
    } );
}